<template>
  <div class="c-mostRatedCategories">
    <h2 class="c-statusChart_title">ESPECIALIDADES MAIS COTADAS</h2>
    <div class="c-mostRatedCategories_body">
      <a class="c-mostRatedCategories_card" v-for="(item, index) in mostRatedCategories" :key="index" :href="categoryLink(item.categorySlug)">
        <component class="c-mostRatedCategories_icon" :is="getIcon(item.category)"  />
        <h3 class="c-mostRatedCategories_name">{{ item.description }}</h3>

        {{ item.slug }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropOptions } from 'vue'
import { mapState, mapActions } from 'vuex'
import { StoreState } from 'Types'
import { categoryIcon } from 'Services/groupIcon'
import { categoryQuotation } from 'routes'

const initialState = () => ({})

export default Vue.extend({
  data() {
    return initialState()
  },

  created() {
    this.getMostRatedCategories()
  },

  computed: {
    ...mapState({
      mostRatedCategories: state => state.quoteRequest.mostRatedCategories,
    }),


  },

  methods: {
    ...mapActions({
      getMostRatedCategories: 'quoteRequest/getMostRatedCategories'
    }),

    getIcon(name) {
      return categoryIcon(name)
    },

    categoryLink(slug) {
      return categoryQuotation.category(slug)
    }
  }
})
</script>

<style lang="scss">
@import "~css/_references";

.c-mostRatedCategories {
  background-color: $v-colorWhite;
  padding: 24px;
  box-shadow: 4px 4px 25px #B1B1B140;
  border-radius: 8px;

  &_title {
    @include f-fontBrand(18px);
    padding-left: 12px;
    border-left: 2px solid #D3EBE8;
    flex-direction: row;
    margin-bottom: 24px;
  }

  &_body {
    display: flex;
    gap: 8px;
    max-width: 370px;
  }

  &_card{
    display: flex;
    flex: 1;
    padding: 16px 8px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 4px;
    border: 1px solid  #D8D7D9;
    width: 33.3%;
  }

  &_icon {
    width: 40px;
    height: 40px;
    fill: $v-colorGreen;
  }

  &_name {
    @include f-fontSystem(12px, #6D6A6E);
    text-align: center;
    line-height: 26px;
    align-self: stretch;
  }
}
</style>